import React from 'react'
import { DraggableCircleStyles } from './Style'

const DraggableItem = (props) => {
    const { percent: isPercent, value, hide } = props

    return (
        <DraggableCircleStyles {...props}>
            {!hide &&
                <div className='circle-content'>
                    {isPercent ? Number(value)?.toFixed(0) : value}
                    {/* {isPercent && "%"} */}
                </div>}
        </DraggableCircleStyles>
    )
}

export default DraggableItem